/*
 * @Author: beenlezhang
 * @Date: 2022-04-06 20:20:47
 * @LastEditors: henghaowu
 * @LastEditTime: 2022-08-05
 * @Descripttion:
 */
interface Map {
  [key: string]: any;
}

const APPLY_COLUMNS: Map[] = [
  { title: '申请内容', dataIndex: 'content', key: 'content' },
  { title: '内容类型', dataIndex: 'categoryName', key: 'categoryName' },
  { title: '申请权限类型', dataIndex: 'roleName', key: 'roleName' },
  { title: '审批通过的权限', dataIndex: 'roleName', key: 'roleName' },
  { title: '当前审批人', dataIndex: 'handlerName', key: 'handlerName' },
  { title: '申请内容的路径', dataIndex: 'location', key: 'location', ellipsis: true },
  { title: '审批进度', dataIndex: 'currentStateName', key: 'currentState' },
];

const APPROVE_COLUMNS: Map[] = [
  { title: '申请人', dataIndex: 'applicantName', key: 'content' },
  { title: '申请内容', dataIndex: 'content', key: 'categoryName' },
  { title: '内容类型', dataIndex: 'categoryName', key: 'roleName' },
  { title: '申请内容的路径', dataIndex: 'location', key: 'roleName', ellipsis: true },
  { title: '申请权限类型', dataIndex: 'roleName', key: 'handler' },
  { title: '审批通过的权限', dataIndex: 'roleName', key: 'location' },
  { title: '审批进度', dataIndex: 'currentStateName', key: 'currentState' },
];

const APPLY_ACTION_COLUMNS: Map[] = [
  ...APPLY_COLUMNS,
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    slots: { customRender: 'action' },
    width: '170px',
  },
];

const APPROVE_ACTION_COLUMNS: Map[] = [
  ...APPROVE_COLUMNS,
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    slots: { customRender: 'action' },
    width: '170px',
  },
];

const QUICK_LOGIN_METHODS = ['wechat', 'wework'];

const QUICK_LOGIN_NAME: Map = {
  wechat: {
    name: '微信',
    channel: 'WX',
  },
  wework: {
    name: '企业微信',
    channel: 'QYWX',
  },
};

// 权限中心菜单精简版
const SIMPLIFY_AUTHORITY_NAV_LIST = [
  {
    label: '个人权限',
  },
  {
    value: window.AppConfig.authority?.applyListRouteName || 'ApplyList',
    label: '我的申请列表',
    desc: window.AppConfig.auth?.showOrg
      ? '灯塔已将待审批单发送至审批人的企业微信，如果紧急，可点击催一催再次向审批人发送企业微信通知。'
      : '',
    selectedName: [window.AppConfig.authority?.applyListRouteName || 'ApplyList'],
  },
  {
    value: window.AppConfig.authority?.approveListRouteName || 'ApproveList',
    label: '我的审批列表',
    selectedName: [window.AppConfig.authority?.approveListRouteName || 'ApproveList'],
  },
  {
    label: '空间权限',
    class: 'menu',
  },
  {
    value: window.AppConfig.authority?.authGroupRouteName || 'AuthRoleGroup',
    label: '角色组管理',
    selectedName: [window.AppConfig.authority?.authGroupRouteName || 'AuthRoleGroup'],
  },
  {
    value: 'AuthRoleGroup',
    label: '申请角色组权限',
    selectedName: ['AuthRoleGroup'],
  },
  {
    value: 'BizMemberManager',
    label: '空间成员管理',
    selectedName: ['BizMemberManager', 'MyDataAuthList'],
  },
  {
    value: 'BizMemberManager',
    label: '查看空间成员',
    selectedName: ['BizMemberManager', 'MyDataAuthList'],
  },
  {
    value: 'AuthProcess',
    label: '权限审批流程设置',
    hide: !window.AppConfig.auth?.showAuthProcess,
    selectedName: ['AuthProcess'],
  },
];

// 权限中心菜单通用版
const COMMON_AUTHORITY_NAV_LIST = [
  {
    label: '个人权限',
  },
  {
    value: 'myAuthList',
    label: '我有权限的',
    selectedName: ['myAuthList', 'AuthDefault'],
  },
  {
    value: 'ApplyList',
    label: '我的申请列表',
    desc: window.AppConfig.auth?.showOrg
      ? '灯塔已将待审批单发送至审批人的企业微信，如果紧急，可点击催一催再次向审批人发送企业微信通知。'
      : '',
    selectedName: ['ApplyList'],
  },
  {
    value: 'ApproveList',
    label: '我的审批列表',
    selectedName: ['ApproveList'],
  },
  {
    label: '空间权限',
    class: 'menu',
  },
  {
    value: 'AuthRoleGroup',
    label: '角色组管理',
    selectedName: ['AuthRoleGroup'],
  },
  {
    value: 'AuthRoleGroup',
    label: '申请角色组权限',
    selectedName: ['AuthRoleGroup'],
  },
  {
    value: 'BizMemberManager',
    label: '空间成员管理',
    selectedName: ['BizMemberManager', 'MyDataAuthList'],
  },
  {
    value: 'BizMemberManager',
    label: '查看空间成员',
    selectedName: ['BizMemberManager', 'MyDataAuthList'],
  },
  {
    value: window.AppConfig.authority?.authProcessRouteName || 'AuthProcess',
    label: '权限审批流程设置',
    hide: !window.AppConfig.auth?.showAuthProcess,
    selectedName: [window.AppConfig.authority?.authProcessRouteName || 'AuthProcess'],
  },
  {
    label: '数据权限',
    class: 'menu',
  },
  {
    value: 'DataGrant',
    label: '数据资产批量授权',
    selectedName: ['DataGrant'],
  },
];

export {
  APPLY_COLUMNS,
  APPLY_ACTION_COLUMNS,
  APPROVE_COLUMNS,
  APPROVE_ACTION_COLUMNS,
  QUICK_LOGIN_METHODS,
  QUICK_LOGIN_NAME,
  SIMPLIFY_AUTHORITY_NAV_LIST,
  COMMON_AUTHORITY_NAV_LIST,
};
